 function chmQrCode(content, imageURL) {
    var image;

    if (imageURL !== false) {
        imageURL = imageURL || ScoreTrekBattle.ASSETS.IMAGES.qrCode;
        image = document.createElement('img');
        image.src = imageURL;
    }

    return kjua({
        // render method: 'canvas', 'image' or 'svg'
        render: 'svg',

        // render pixel-perfect lines
        crisp: true,

        // minimum version: 1..40
        minVersion: 1,

        // error correction level: 'L', 'M', 'Q' or 'H'
        ecLevel: 'H',

        // size in pixel
        size: 500,

        // pixel-ratio, null for devicePixelRatio
        ratio: null,

        // code color
        fill: '#000',

        // background color
        back: '#fff',

        // content
        text: content,

        // roundend corners in pc: 0..100
        rounded: 0,

        // quiet zone in modules
        quiet: 1,

        // modes: 'plain', 'label' or 'image'
        mode: image ? 'image' : 'plain',

        // label/image size and pos in pc: 0..100
        mSize: 30,
        mPosX: 50,
        mPosY: 50,

        // // label
        // label: '',
        // fontname: 'sans',
        // fontcolor: '#333',

        // image element
        image: image ? image : null
    });
}
